// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_SPA_FAILED_MODE
});

export const updateDownTimeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'downtime',
    type: actions.UPDATE_CLAIM_SPA_DOWN_TIME
});

export const updateSpaClaimFailedArea = value => ({
    property: 'failureArea',
    type: actions.UPDATE_CLAIM_SPA_FAILED_AREA,
    value
});

export const updateSpaClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_SPA_PART_SERIAL_NUMBER,
    value
});

export const updateSpaClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_SPA_FAILED_MODE_COMMENTS,
    value
});

export const updateSpaClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_SPA_DTAC_CASE,
    value
});

export const updateSpaClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_SPA_DTAC_SOLUTION,
    value
});

export const updateSpaClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_SPA_OPERATORS_COMPLAINT,
    value
});

export const updateSpaClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_SPA_COMPLAINT_CAUSE,
    value
});

export const updateSpaClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_SPA_COMPLAINT_CORRECTION,
    value
});

export const updateSpaClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_SPA_OPERATORS_COMMENTS,
    value
});

export const updateSpaClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_SPA_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/failure-panel.js